<template>
    <KeepAlive>
        <component :is="asyncComponent" v-bind="$props">
            <template v-for="(_, name) in $slots" #[name]>
                <slot :name="name"></slot>
            </template>
        </component>
    </KeepAlive>
</template>

<script setup lang="ts">
import { PropType, defineOptions, defineProps, defineAsyncComponent, computed } from 'vue'

defineOptions({
    name: 'v-input'
})

type InputMode = 'default' | 'other'

const props = defineProps({
    mode: {
        type: String as PropType<InputMode>,
        required: false,
        default: 'default'
    },
})

const capitalizedMode = computed(() => props.mode?.toCapitalize?.())

const asyncComponent = defineAsyncComponent(async () => {
  const { default: component } = await import(`./${capitalizedMode.value}Input.vue`);
  return component;
});

</script>